import React from 'react';
import PropTypes from 'prop-types';
import ActionColumn from 'screens/common/components/ActionColumn';

const CardDetailsModal = ({
  cardTittles,
  handleCloseModal,
  selectedRowData,
  handleAction
}) => {
  return (
    <div
      className="modal"
      style={{
        display: 'block',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
        backdropFilter: 'blur(5px)'
      }}
      onClick={handleCloseModal}
    >
      <div className="modal-dialog" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          {/* Modal Header */}
          <div
            className="w-100 d-flex align-items-center"
            style={{ backgroundColor: '#d6f3f8' }}
          >
            <button
              type="button"
              className="close"
              onClick={handleCloseModal}
              aria-label="Close"
              style={{
                border: 'none',
                background: 'transparent',
                fontSize: '2.5rem',
                color: '#333',
                cursor: 'pointer',
                backgroundColor: '#d6f3f8'
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <div>
              <h5 className="fs-2 fw-semibold ms-2">Details</h5>
            </div>
          </div>

          {/* Modal Body */}
          <div
            className="modal-body text-center"
            style={{
              maxHeight: '90vh', // Set the height (adjust as needed)
              overflowY: 'auto' // Make the content scrollable vertically
            }}
          >
            <div
              className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mb-2"
              style={{
                width: '80px',
                height: '80px',
                fontSize: '30px',
                fontWeight: 'bold',
                margin: '0 auto'
              }}
            >
              {(selectedRowData.original[cardTittles[0]] ||
                'Unknown User')[0].toUpperCase()}
            </div>
            <h5>
              {selectedRowData.original[cardTittles[0]] || 'Unknown User'}
            </h5>
            {selectedRowData.cells &&
              selectedRowData.cells.map((cell, cellIndex) => {
                // Check if the first word of the Header is not "section"
                if (cell.column?.Header !== 'Action') {
                  const isSection =
                    cell.column?.Header?.split(' ')[0]?.toLowerCase() ===
                    'section';

                  return !isSection ? (
                    <div
                      className="d-flex mb-1 text-muted w-100 align-items-center"
                      key={cellIndex}
                    >
                      {/* First Column: Header */}
                      <div className="text-start" style={{ flex: 3 }}>
                        <strong>{cell.column.Header}</strong>
                      </div>

                      {/* Middle Column: Colon */}
                      <div className="text-center" style={{ flex: 1 }}>
                        <span>:</span>
                      </div>

                      {/* Last Column: Value */}
                      <div className="text-start" style={{ flex: 4 }}>
                        <span>
                          {Array.isArray(cell.value)
                            ? cell.value.join(', ')
                            : cell.render('Cell')}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="text-start fw-bold mt-3 mb-1"
                      style={{ flex: 4 }}
                    >
                      <span>
                        {Array.isArray(cell.value)
                          ? cell.value.join(', ')
                          : cell.render('Cell')}
                      </span>
                    </div>
                  );
                }
                // Render nothing if the first word is "section"
              })}
            {/* Action buttons */}
            <div className="d-flex justify-content-end mt-4 gap-2 p-3">
              <ActionColumn row={selectedRowData} handleAction={handleAction} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
CardDetailsModal.propTypes = {
  cardTittles: PropTypes.arrayOf(PropTypes.string),
  handleCloseModal: PropTypes.func,
  selectedRowData: PropTypes.object,
  handleAction: PropTypes.func.isRequired
};

export default CardDetailsModal;
